import { inject, Injectable } from '@angular/core';
import { PackingSlip } from '../model/packing-slip';
import { AppInformationService } from '../app-information.service';
import { GenesisUnitOfWork } from './genesis-unit-of-work';
import { alert, confirm } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import _ from 'lodash';
import { Dealer, Invoice, InvoiceFee, InvoiceLine, InvoiceStatus, OrderLineDetail, OrderLineStatus, Payment, PaymentLine, PaymentLineType } from '../model/entity-model';
import { AuthService } from '../auth.service';
import { EntitiesService, UtilityService } from '../core.module';
import { Router } from '@angular/router';
import { EmailDialogComponent } from 'app/shared/email-dialog/email-dialog.component';
import { Utility } from '../utility';
// import { InvoiceDetailComponent } from 'app/invoices/invoice-detail/invoice-detail.component';

@Injectable()
export class InvoiceService {
    router = inject(Router);

    constructor(
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
        public auth: AuthService,
        private utility: UtilityService,
        private entitiesService: EntitiesService,
    ) {}

    async openInvoice(invoiceNumber: number) {
        const entity = await this.uow.getInvoiceByInvoiceNumber(invoiceNumber);
        if (!entity) return;
        this.router.navigate([`/invoices/${entity.id}`]);
    }

    async openInvoiceDialog(invoice: Invoice) {
        // const modalRef = this.modalService.show(InvoiceDetailComponent, {
        //     class: 'modal-lg',
        //     ignoreBackdropClick: true,
        //     keyboard: false,
        //     initialState: {
        //         showAsDialog: true,
        //         invoiceId: invoice.id,
        //     },
        // });
        // modalRef.content.result.subscribe(async (result) => {
        //     if (result.success && !!result.value) {
        //         // this.appInfo.pleaseWaitShow();
        //         // const emailSent = await this.utility.sendEmail(result.value);
        //         // await this.uow.commit();
        //         // this.appInfo.pleaseWaitHide();
        //         // await alert(emailSent ? 'Email Sent!' : 'An error occurred while sending the email.', this.appInfo.settings.company);
        //     }
        //     modalRef.hide();
        // });
    }

    async receivePayment(invoice: Invoice, credit?: boolean): Promise<boolean> {
        let creditPayment;
        const credits = []; // await this.checkForCredits(invoice);

        if (credits?.length > 0) {
            // creditPayment = await this.applyCredits(invoice, credits[0]);
            // await this.uow.commit();
            // await this.updateBalances([invoice.id]);
        }

        if (!credits || credits.length === 0 || credits[0].amount < invoice.total) {
        } else {
            await alert(`Payment Credits applied. Payment Id: ${creditPayment.id} has been updated.`, this.appInfo.settings.company);
            return true;
        }

        await this.uow.commit();
        if (!!credit) this.router.navigate([`/payments/creditPayment/${invoice.dealerId}/${invoice.id}`]);
        else this.router.navigate([`/payments/new/${invoice.dealerId}/${invoice.id}`]);
    }

    async getAttachments(packingSlipId: number) {
        if (!packingSlipId) return [];

        const attachments = await this.uow.getPackingSlipAttachments(packingSlipId);
        const photos = await this.uow.getPhotos(packingSlipId, 'Pack Slip');
        return _([...attachments, ...photos])
            .orderBy('name')
            .valueOf();
    }

    async readyToExport(invoices: Invoice[]) {
        const result = await confirm(`Are you sure you want to mark as Ready To Export for Quickbooks?`, `${this.appInfo.settings.company}`);
        if (!result) return;
        const today = new Date();
        invoices.forEach((invoice) => {
            invoice.readyToExport = today;
            invoice.readyToExportBy = this.auth.currentUser.userName;
        });
        await this.uow.commit();
    }

    async removeFromPackSlip(orderLineDetails: OrderLineDetail[]) {
        if (!orderLineDetails || orderLineDetails.length === 0) return;

        const hasPackSlipsReadyToExport = orderLineDetails.some((orderLineDetail) => orderLineDetail.packingSlip.readyToExport);
        if (hasPackSlipsReadyToExport) {
            await alert('Items cannot be removed if the Packing Slip is ready to be exported', this.appInfo.settings.company);
            return;
        }

        const result = await confirm(
            `Are you sure you want to remove ${
                orderLineDetails.length === 1 ? 'this item' : 'these items'
            } from their assigned Packing Slips?  This will set the status back to NEW or BUILT.`,
            this.appInfo.settings.company,
        );
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const packSlipIds = orderLineDetails.map((x) => {
            return x.packingSlipId;
        });
        let detailIds = [];
        let builtDatesMatch = true;
        orderLineDetails.forEach((orderLineDetail) => {
            detailIds.push(orderLineDetail.id);
            orderLineDetail.packingSlipId = null;

            // either order and options have a built date, or order and options don't have a built date
            const optionBuiltDatesMatch = orderLineDetail.optionDetails.length === 0 || orderLineDetail.optionDetails.every((option) => !!option.built === !!orderLineDetail.built);
            if (!optionBuiltDatesMatch) builtDatesMatch = false;
            orderLineDetail.statusId = orderLineDetail.built && optionBuiltDatesMatch ? OrderLineStatus.OrderLineStatusOptions.Built : OrderLineStatus.OrderLineStatusOptions.New;

            orderLineDetail.optionDetails.forEach((option) => {
                detailIds.push(option.id);
                option.packingSlipId = null;
                option.statusId = option.built && optionBuiltDatesMatch ? OrderLineStatus.OrderLineStatusOptions.Built : OrderLineStatus.OrderLineStatusOptions.New;
            });
            this.entitiesService.createOrderLineDetailNote(orderLineDetail.id, `Removed from pack slip`, this.auth.currentUser.id);
        });
        await this.uow.commit();
        await this.utility.setPaymentLinePackSlipId(detailIds, null);
        await this.checkPackSlip(packSlipIds);
        this.appInfo.pleaseWaitHide();

        if (!builtDatesMatch) {
            await alert('Some of the built items have unbuilt options. The statuses for these items and options have been set to NEW', this.appInfo.settings.company);
        }
    }

    async checkPackSlip(packSlipIds: number[]) {
        const uniqueIds = _.uniq(packSlipIds);
        for (let index = 0; index < uniqueIds.length; index++) {
            const id = uniqueIds[index];
            const details = await this.uow.getOrderLineDetailsByPackSlipId(id);
            if (details.length === 0) {
                const packSlip = (await this.uow.packingSlips.byId(id)) as any;
                packSlip.deleted = new Date();
                packSlip.deletedBy = `${this.auth.currentUser.userName} -- Last Detail removed from pack slip`;
            }
        }
        await this.uow.commit();
    }

    async createInvoice(ids: number[], mode: 'salesOrder' | 'packingSlip') {
        let details;
        if (mode === 'salesOrder') details = await this.uow.getOrderLineDetailsForInvoicingByOrderIds(ids);
        if (mode === 'packingSlip') details = await this.uow.getOrderLineDetailsForInvoicingByPackingSlipIds(ids);

        if (details.nonInvoicedOrderLineDetails.length === 0 && details.nonInvoicedFreightPackingSlips.length === 0) {
            await alert(`There are no order lines that haven't already been invoiced.`, this.appInfo.settings.company);
            return;
        }
        if (details.nonInvoicedOrderLineDetails.length > 0 && details.nonInvoicedOrderLineDetails.length !== details.orderLineDetails.length) {
            const result = await confirm(
                'Some of the OrderLines have already been invoiced.  An invoice for the remaining lines will be created. Continue?',
                this.appInfo.settings.company,
            );
            if (!result) return;
        }
        if (details.nonInvoicedOrderLineDetails.length > 0 && details.nonInvoicedOrderLineDetails.every((x) => !!x.isOption)) {
            await alert(`Only Options details. Add them to the invoices where their parent line is.`, this.appInfo.settings.company);
            return;
        }

        if (mode === 'salesOrder') this.router.navigate(['/invoices/new'], { queryParams: { orderIds: JSON.stringify(ids) } });
        if (mode === 'packingSlip') this.router.navigate(['/invoices/new'], { queryParams: { packingSlipIds: JSON.stringify(ids) } });
    }

    async sortInvoiceLines(invoiceLines: InvoiceLine[]) {
        let sortedLines = [];
        let lines = _.orderBy(
            invoiceLines.filter((x) => !!x.orderLineDetailId && x.orderLineDetail.parentLineId == null && !x.deleted),
            ['orderLineDetailId'],
            ['asc'],
        );
        let lineNumber = 1;
        for (let index = 0; index < lines.length; index++) {
            const line = lines[index];
            line.lineNumber = lineNumber;
            lineNumber++;
            sortedLines.push(line);

            const children = invoiceLines.filter((x: any) => x.orderLineDetail.parentLineId === line.orderLineDetailId);
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                child.lineNumber = lineNumber;
                lineNumber++;
                sortedLines.push(child);
            }
        }

        // Include the invoiceLines not added to sortedLines
        const leftOverLines = invoiceLines.filter((x) => !sortedLines.includes(x) && !x.deleted);
        leftOverLines.forEach((line) => {
            line.lineNumber = lineNumber;
            lineNumber++;
        });
    }

    async deleteInvoices(invoiceIds: number[]): Promise<boolean> {
        for (const invoiceId of invoiceIds) {
            const achTransactions = await this.uow.getAchTransactionsByInvoiceId(invoiceId);
            if (achTransactions.length > 0) {
                await alert(`ACH Transactions for this invoice need to be deleted first.`, this.appInfo.settings.company);
                return false;
            }

            const paymentLines = await this.uow.getPaymentLinesByInvoiceId(invoiceId);
            if (paymentLines.length > 0) {
                await alert(`Payment Lines for this invoice need to be deleted first.`, this.appInfo.settings.company);
                return false;
            }
        }
        const result = await confirm(`Are you sure you want to delete ${invoiceIds.length === 1 ? 'this Invoice' : 'these Invoices'}?`, this.appInfo.settings.company);
        if (!result) return false;

        this.appInfo.pleaseWaitShow();
        for (const invoiceId of invoiceIds) {
            const invoice = (await this.uow.invoices.byId(invoiceId, 'invoiceLines, orderLineDetails')) as Invoice;
            if (invoice.quickBooksId !== null) {
                this.appInfo.pleaseWaitHide();
                const result = await confirm(
                    `This invoice has already been exported to QuickBooks.  If you delete it, it will need to be manually deleted from QuickBooks. Continue?`,
                    this.appInfo.settings.company,
                );
                if (!result) return false;
            }
            invoice.deleted = new Date();
            invoice.deletedBy = this.auth.currentUser.userName;
            for (const line of invoice.invoiceLines) {
                line.deleted = new Date();
                line.deletedBy = this.auth.currentUser.userName;
                if (line.partNumber.toLowerCase() === 'freight') {
                    const packingSlips = await this.uow.getPackingSlipByFreightInvoiceId(invoiceId);
                    packingSlips.forEach((packingSlip) => {
                        packingSlip.freightInvoiceId = null;
                    });
                }
            }
            const details = [...invoice.orderLineDetails];
            let i = 0;
            for (const detail of details) {
                console.log('removing detail from invoice', detail.id);
                detail.invoiceId = null;
                i++;
            }
            console.log(`removed ${i} details from invoice`);
        }
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
        return true;
    }

    async emailInvoice(invoice: Invoice) {
        if (!invoice) return;
        const body = ((await this.uow.getSettingsByName('InvoiceEmailBody')) as any).stringValue;

        const modalRef = this.modalService.show(EmailDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                mode: 'Invoice',
                entityId: invoice.id,
                dealerEmail: invoice.dealer.aPEmail ?? invoice.dealer.email,
                body: body,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && !!result.value) {
                this.appInfo.pleaseWaitShow();
                const emailSent = await this.utility.emailReport(result.value);
                invoice.emailed = new Date();
                await this.uow.commit();
                this.appInfo.pleaseWaitHide();
                await alert(emailSent ? 'Email Sent!' : 'An error occurred while sending the email.', this.appInfo.settings.company);
            }
            modalRef.hide();
        });
    }

    async paymentsReadyToExport(payments: Payment[]) {
        const result = await confirm(`Are you sure you want to mark as Ready To Export for Quickbooks?`, `${this.appInfo.settings.company}`);
        if (!result) return;
        const today = new Date();
        payments.forEach((payment) => {
            payment.readyToExport = today;
        });
        await this.uow.commit();
    }

    async updateInvoiceStatus(invoiceLines: InvoiceLine[], paymentLines: PaymentLine[]): Promise<number> {
        const invoiceSum = Utility.round(
            _.sumBy(
                invoiceLines.filter((line) => !line.deleted),
                (line) => line.price * line.quantity,
            ),
            2,
        );
        const paymentSum = Utility.round(
            _.sumBy(
                paymentLines.filter((line) => !line.deleted),
                'amount',
            ),
            2,
        );

        console.log('invoiceSum', invoiceSum);
        console.log('paymentSum', paymentSum);
        if (invoiceSum === paymentSum) {
            return InvoiceStatus.Statuses.Paid;
        }
        if (paymentSum < invoiceSum && paymentSum > 0) {
            return InvoiceStatus.Statuses.PartiallyPaid;
        }
        if (paymentSum === 0) {
            return InvoiceStatus.Statuses.New;
        }
    }
}
